import React from 'react';

import { EuiFlexGroup, EuiFlexItem } from '../../../../src/components/flex';

export default () => (
  <EuiFlexGroup>
    <EuiFlexItem>One</EuiFlexItem>
    <EuiFlexItem>Two</EuiFlexItem>
    <EuiFlexItem>Three</EuiFlexItem>
    <EuiFlexItem>Four</EuiFlexItem>
    <EuiFlexItem>Five</EuiFlexItem>
  </EuiFlexGroup>
);
